import { GroupStatusEvent, useIM } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const SEPARATOR = '_'

export const useConferenceAllowedParticipantsStore = defineStore('conference-allowed-participant', () => {
  const allowedParticipantsByRoomPServed = ref(new Map<string, true>())

  const getContactId = (pServed: string, contactId: string) => `${pServed}${SEPARATOR}${contactId}`

  const getIsAllowedParticipant = (pServed: string, contactId: string): boolean => allowedParticipantsByRoomPServed.value.get(getContactId(pServed, contactId)) ?? false

  useIM().onConferenceUpdated((event: GroupStatusEvent) => {
    const { extendedParams: { contacts }, pServed } = event
    if (!contacts?.length || !pServed) {
      return
    }

    contacts.forEach(({ isAllowedParticipation, id }) => {
      const contactId = getContactId(pServed, id)
      if (isAllowedParticipation) {
        allowedParticipantsByRoomPServed.value.set(contactId, isAllowedParticipation)
      } else {
        allowedParticipantsByRoomPServed.value.delete(contactId)
      }
    })
  })

  return {
    getIsAllowedParticipant,
  }
})
